/** OpenRouter 集成 API；请求与响应契约来自 shared，API Key 永不回显。 */
import type {
  OpenRouterCredentialResponse,
  UpsertOpenRouterCredentialRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const openrouterApi = {
  /** 读全局凭证视图（掩码；未配置 → configured:false） */
  getCredential: () =>
    apiRequest<OpenRouterCredentialResponse>({
      method: 'GET',
      path: '/api/v1/integrations/openrouter/credential',
    }),
  /** 录 / 换全局 DeepL Key（后端先 ping 验证再加密存；明文仅提交） */
  upsertKey: (body: UpsertOpenRouterCredentialRequest) =>
    apiRequest<OpenRouterCredentialResponse>({
      method: 'PUT',
      path: '/api/v1/integrations/openrouter/credential',
      body,
    }),
  /** 移除全局凭证（软删，可再录入） */
  removeKey: () =>
    apiRequest<{ removed: true }>({
      method: 'DELETE',
      path: '/api/v1/integrations/openrouter/credential',
    }),
  /** 测试连接（解密已存 Key + ping DeepL /v2/usage，更新 status） */
  testConnection: () =>
    apiRequest<{ connected: true }>({
      method: 'POST',
      path: '/api/v1/integrations/openrouter/credential/test',
    }),
};
